import client from './client';

export default (function PdfService() {
  let service;

  if (!service) {
    service = client.service('pdf');
  }

  return service;
}());
